import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-end my-s" }
const _hoisted_2 = { class: "text-gray-600" }


export default /*#__PURE__*/_defineComponent({
  __name: 'VersionDisplay',
  setup(__props) {

const version = process.env.VUE_APP_VERSION || "undefined";

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("small", _hoisted_2, _toDisplayString(_unref(version)), 1)
  ]))
}
}

})